import { useState } from 'react';

export const useUploadImage = () => {
  const [images, setImages] = useState([]);
  const [imageUploadError, setImageUploadError] = useState(false);

  const handleImageUpload = (e) => {
    if (images.length + e.target.files.length > 5) {
      setImageUploadError(true);
      return;
    }

    const files = Array.from(e.target.files);
    const emptySlots = 5 - images.length;

    // 빈 슬롯만큼만 이미지 추가
    const newFiles = files.slice(0, emptySlots).map((file) => {
      return {
        id: Date.now() + Math.random(),
        file,
        preview: URL.createObjectURL(file),
      };
    });

    if (newFiles.length > 0) {
      setImages((prev) => [...prev, ...newFiles]);
    }
  };

  const handleRemoveImage = (id) => {
    setImages((prev) => prev.filter((image) => image.id !== id));
  };

  return { images, handleImageUpload, handleRemoveImage, imageUploadError, setImageUploadError };
};
